module.exports = "<h2 class=\"title\">{{ attributes.title }}</h2>\n<p class=\"body\">{{ attributes.body }}</p>\n<div class=\"actions\">\n  <button class=\"btn btn-cancel close\" (click)=\"confirmDialog.close(false)\">{{ attributes.close }}</button>\n  <button class=\"btn btn-green accept\" *ngIf=\"attributes.accept\" (click)=\"confirmDialog.close(true)\">{{ attributes.accept }}</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dialogs/confirm-dialog.component.html
// module id = ./src/app/shared/dialogs/confirm-dialog.component.html
// module chunks = main